import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../../constants/common'

import {
  LISTING_ATTENTION_ACTION_DESTINATION,
  LISTING_ATTENTION_DESTINATION,
  LISTING_ATTENTION_READINESS_DESTINATION,
} from './useListingProfileAttentionAction.constants'

function getListingAttentionDestination({ primaryAction, publishReadiness }) {
  const destination =
    LISTING_ATTENTION_ACTION_DESTINATION[primaryAction.key] ?? null

  return destination === LISTING_ATTENTION_DESTINATION.readiness
    ? (LISTING_ATTENTION_READINESS_DESTINATION[
        (publishReadiness ?? EMPTY_LIST).find(item => !item.is_done)?.key
      ] ?? null)
    : destination
}

function getListingAttentionDestinationGate({ canEditPhotos, permissions }) {
  const editGate = {
    isAllowed: permissions.can_edit,
    notAllowedTooltipKey: 'RentalPortal.ListingEditNotAllowedTooltipKey',
  }

  return {
    [LISTING_ATTENTION_DESTINATION.applicants]: {
      isAllowed: permissions.can_view_applicants,
      notAllowedTooltipKey:
        'RentalPortal.ListingProfileApplicantsNotAllowedTooltipKey',
    },
    [LISTING_ATTENTION_DESTINATION.descriptionEdit]: editGate,
    [LISTING_ATTENTION_DESTINATION.keyFactsEdit]: editGate,
    [LISTING_ATTENTION_DESTINATION.managerEdit]: editGate,
    [LISTING_ATTENTION_DESTINATION.photoEditor]: {
      isAllowed: canEditPhotos,
      notAllowedTooltipKey: 'RentalPortal.ListingEditNotAllowedTooltipKey',
    },
    [LISTING_ATTENTION_DESTINATION.publishing]: {
      isAllowed: permissions.can_view_publications,
      notAllowedTooltipKey:
        'RentalPortal.ListingProfileManagePublishingNotAllowedTooltipKey',
    },
  }
}

export function getListingAttentionActionState({ canEditPhotos, listing }) {
  const primaryAction = listing?.attention?.primary_action

  if (!primaryAction) {
    return { destination: null, isDisabled: true, tooltipKey: null }
  }

  const destination = getListingAttentionDestination({
    primaryAction,
    publishReadiness: listing.publish_readiness,
  })

  if (!destination) {
    return {
      destination: null,
      isDisabled: true,
      tooltipKey: 'RentalPortal.ListingProfileAttentionUnknownTooltipKey',
    }
  }

  const { isAllowed, notAllowedTooltipKey } =
    getListingAttentionDestinationGate({
      canEditPhotos,
      permissions: listing.permissions ?? EMPTY_OBJECT,
    })[destination]

  return isAllowed
    ? { destination, isDisabled: false, tooltipKey: null }
    : { destination, isDisabled: true, tooltipKey: notAllowedTooltipKey }
}

export function getIsListingAttentionDestinationPublishing(destination) {
  return destination === LISTING_ATTENTION_DESTINATION.publishing
}
